import React from "react";
import DashboardHeader from "../../components/Admin/DashboardHeader";
import DashboardSideBar from "../../components/Admin/DashboardSideBar";
import CreateCategory from "../../components/Admin/CreateCategory";
import "./AdminCategory.scss";

const AdminCategory = () => {
  return (
    <div className="admin-category">
      <DashboardHeader />

      <div className="admin-category__wrapper">
        <div className="admin-category__container">
          <div className="admin-category__sidebar">
            <DashboardSideBar active={3} />
          </div>

          <div className="admin-category__content">
            <CreateCategory /> 
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCategory;